/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './equipment.reducer';

export const EquipmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const equipmentEntity = useAppSelector(state => state.equipment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="equipmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.equipment.detail.title">Equipment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.equipment.id">Id</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.id}</dd>
          <dt>
            <span id="modality">
              <Translate contentKey="tinyMedicRestApp.equipment.modality">Modality</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.modality}</dd>
          <dt>
            <span id="conversionType">
              <Translate contentKey="tinyMedicRestApp.equipment.conversionType">Conversion Type</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.conversionType}</dd>
          <dt>
            <span id="stationName">
              <Translate contentKey="tinyMedicRestApp.equipment.stationName">Station Name</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.stationName}</dd>
          <dt>
            <span id="institutionName">
              <Translate contentKey="tinyMedicRestApp.equipment.institutionName">Institution Name</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.institutionName}</dd>
          <dt>
            <span id="institutionAddress">
              <Translate contentKey="tinyMedicRestApp.equipment.institutionAddress">Institution Address</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.institutionAddress}</dd>
          <dt>
            <span id="institutionalDepartmentName">
              <Translate contentKey="tinyMedicRestApp.equipment.institutionalDepartmentName">Institutional Department Name</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.institutionalDepartmentName}</dd>
          <dt>
            <span id="manufacturer">
              <Translate contentKey="tinyMedicRestApp.equipment.manufacturer">Manufacturer</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.manufacturer}</dd>
          <dt>
            <span id="manufacturerModelName">
              <Translate contentKey="tinyMedicRestApp.equipment.manufacturerModelName">Manufacturer Model Name</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.manufacturerModelName}</dd>
          <dt>
            <span id="softwareVersion">
              <Translate contentKey="tinyMedicRestApp.equipment.softwareVersion">Software Version</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.softwareVersion}</dd>
          <dt>
            <span id="deviceSerialNumber">
              <Translate contentKey="tinyMedicRestApp.equipment.deviceSerialNumber">Device Serial Number</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.deviceSerialNumber}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.equipment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.equipment.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.equipment.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.equipment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.equipment.active">Active</Translate>
            </span>
          </dt>
          <dd>{equipmentEntity.active ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/equipment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/equipment/${equipmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EquipmentDetail;
